// extracted by mini-css-extract-plugin
export default {"myBtn":"Button_yellow_myBtn__0E3TV"};